export default __webpack_public_path__ + "static/media/bg1.7b15ef19.png";